import {
    AggregationKeyFigures,
    KeyFigureData,
    StatementKeyFigures
} from 'components/context/types';

export const prepareAggregationsToKeyFigureData = (
    aggregationKeyFigures: AggregationKeyFigures[],
    seriesName: string,
    sampleLowerLimit?: number
): KeyFigureData => {
    const keyFigureData: KeyFigureData = {
        seriesName,
        keyFigures: aggregationKeyFigures.map(aggregation => ({
            businessId: '',
            statementDate: aggregation.targetYear + '-1-1',
            turnover: aggregation.turnover,
            turnoverGrowthPercent: aggregation.turnoverGrowthPercent,
            returnOnInvestmentPercent: aggregation.returnOnInvestmentPercent,
            netProfit: aggregation.netProfit,
            netProfitPerTurnover: aggregation.netProfitPerTurnover,
            currentRatio: aggregation.currentRatio,
            equityRatio: aggregation.equityRatio,
            sampleSize: aggregation.sampleSize
        })) as StatementKeyFigures[]
    };

    return filterAndSortKeyFigureData(keyFigureData, sampleLowerLimit);
};

export const filterAndSortKeyFigureData = (
    keyFigureData: KeyFigureData,
    sampleLowerLimit?: number
): KeyFigureData => {
    const { seriesName, keyFigures } = keyFigureData;
    // NOTE: Make a copy before sorting so that original array is not affected.
    const sortedKeyFigures: StatementKeyFigures[] = [...keyFigures]
        .filter((figs: StatementKeyFigures) => {
            if (figs.sampleSize && sampleLowerLimit) {
                return figs.sampleSize > sampleLowerLimit;
            } else if (!(figs.sampleSize === undefined)) {
                return figs.sampleSize && figs.sampleSize > 0;
            } else {
                return true;
            }
        })
        .sort((a, b) => {
            if (a.statementDate < b.statementDate) return -1;
            else if (a.statementDate > b.statementDate) return 1;
            else return 0;
        });
    return {
        seriesName,
        keyFigures: sortedKeyFigures
    };
};
